<template>
  <section>
    <h1>比赛列表</h1>
 <el-button @click="addFormVisible=true">新增比赛</el-button>


    <el-table :data="contestList" highlight-current-row v-loading="false"style="width: 100%;">
      <el-table-column prop="id" label="id" sortable>
      </el-table-column>
      <el-table-column prop="desc" label="比赛描述">
      </el-table-column>
      <el-table-column prop="year" label="年" >
      </el-table-column>
      <el-table-column prop="month" label="月" >
      </el-table-column>
      <el-table-column prop="day" label="日" >
      </el-table-column>
      <el-table-column prop="statusdesc" label="状态" >
      </el-table-column>
       <el-table-column align="center" label="操作" >
        <template scope="scope">
          <el-button type="danger" @click="goDetial(scope.row.id)">比赛详情修改</el-button>
        </template>
      </el-table-column>
    </el-table>
      <el-dialog title="新增" :visible="addFormVisible" :close-on-click-modal="false">
        <el-form>
          <el-form-item label="比赛描述" prop="name">
            <el-input v-model="addForm.desc"></el-input>
          </el-form-item>
          <el-form-item label="比赛的年">
            <el-input v-model="addForm.year"></el-input>
          </el-form-item>
          <el-form-item label="月">
            <el-input v-model="addForm.month"></el-input>
          </el-form-item>
          <el-form-item label="日">
            <el-input v-model="addForm.day"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit">提交</el-button>
        </div>
      </el-dialog>
  </section>
</template>

<script>
  export default {
    name: 'region',
    data() {
      return {
          addFormVisible:false,
        contestList:[],
          addForm:{},
      }
    },
    methods:{
        goDetial(id){
            this.$router.push( {name: 'contestDetail', params: { id:id}})
        },
      getData(){
          this.$http.getData('contest',(data)=>{
              this.contestList=data;
          },(data)=>{
              this.$message.error(data.message);
          })
      },
        addSubmit(){
            this.$http.postData('contest',this.addForm,(data)=>{
                this.$message.success(data.message);
                this.addFormVisible=false;
                this.addForm={};
                this.getData();
            },(data)=>{
                this.$message.error(data.message);
            })
        }
    },
    created(){
      this.getData()
    },
  }
</script>

<style scoped>
</style>
